import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AutenticacionService } from 'app/services/autenticacion.service';
import { MenuService } from 'app/services/menu.service';


@Component({
  selector: 'app-admin-layout',
  templateUrl: './admin-layout.component.html',
  styleUrls: ['./admin-layout.component.scss']
})

export class AdminLayoutComponent implements OnInit {
  nameUser: string;
  compress = false;
  token: string;
  classListItem = '';
  ___autenticacionService: AutenticacionService;
  routes = [];


  constructor(private router: Router,
              private _menuService: MenuService,
              private _autenticacionService: AutenticacionService) {
    this.___autenticacionService = _autenticacionService;
  }

  ngOnInit() {
    this.token = localStorage.getItem('ACCESS_TOKEN');
        
    this._menuService.existeCambioMenu.subscribe(r=>{
      this.routes = this.construirMenu(null);
    });
    
    this._menuService.existeCambioMenu.next();

    this.classListItem = sessionStorage.getItem('item-list') !== null ? sessionStorage.getItem('item-list') : window.location.hash.replace('#', '');

    this.nameUser = localStorage.getItem("USER_LOGIN");
  }

  construirMenu(padreId: number){
    let rutas:Array<any> = JSON.parse(localStorage.getItem("MENU"));
    if(rutas){
      rutas.sort(function(a, b) {
        if(!a.menuOrder){
          a.menuOrder = 0;
        }
        if(!b.menuOrder){
          b.menuOrder = 0;
        }
        return a.menuOrder - b.menuOrder;
      });
    }

    let retorno: Array<any> = [];
    if(padreId){
      rutas.forEach(ruta=>{
        if(ruta.idParent==padreId){
          let opcion:any = {type: 'paths', titleMenu: ruta.nameRoute , compress:false, img: ruta.icon, paths: this.construirMenu(ruta.idRoute)};
          if(ruta.path && ruta.path!='null'){
            opcion.type = 'path';
            opcion.path = ruta.path;
            delete opcion.compress;
          }

          if(opcion.paths.length==0){
            delete opcion.paths;
          }
          retorno.push(opcion);
        }
      });
    }else{
      if(rutas){
        rutas.forEach(ruta=>{
          if(!ruta.idParent){
            if(ruta.path && ruta.path!='null'){
              retorno.push({type: 'path', titleMenu: ruta.nameRoute , path: ruta.path, img: ruta.icon});
            }else{
              retorno.push({type: 'paths', titleMenu: ruta.nameRoute , compress:false, img: ruta.icon, paths: this.construirMenu(ruta.idRoute)});
            }
          }
        });
      }
    }
    return retorno;
  }

  getUserLogin(){
    return localStorage.getItem("USER_LOGIN");
  }

  logout() {
    this._autenticacionService.borrarSesion();
    this.router.navigateByUrl('/login');
  }

  changeItem(item: string) {
    sessionStorage.setItem('item-list', item);
    this.classListItem = sessionStorage.getItem('item-list');
    this.router.navigate([item]);
  }
}
